type Props = {
  searchText: string
  setHandler: React.Dispatch<React.SetStateAction<string>>
}

export const SearchInput = (props: Props) => {
  const { searchText, setHandler } = props
  const baseStyle =
    'flex-1 rounded-md border border-[#ddd] px-4 py-2.5 text-sm outline-none'

  return (
    <input
      type={'text'}
      value={searchText}
      onChange={(event) => {
        setHandler(event.target.value)
      }}
      placeholder={'検索する'}
      className={baseStyle}
    />
  )
}
